import csv from 'csvtojson'
import testimonies from '../data/testimonies.csv'
import { split } from 'sentence-splitter'


export async function getSpreadsheetData() {
	const response = await fetch(testimonies)
	const text = await response.text()
	const rows = await csv().fromString(text)

	for (let i=0; i<rows.length; i++) {
		const sentences = []
		let nodes = split(rows[i].Testimony_English)

		if(rows[i].Testimony_Dari){
			console.log(rows[i].Testimony_Dari)
			nodes = split(rows[i].Testimony_Dari)
		}
		nodes.forEach(node => {
			if (node.type === 'Sentence') {
				// console.log(node.raw)
				const parts = node.raw.split('…')
				parts.forEach(part => {
					const sentence = part.trim()
					if (sentence && sentence.length > 1) {
						// console.log(sentence)
						sentences.push(sentence)
					}
				})
				// console.log('-----')
			}
		})

		rows[i].sentences = sentences
	}

	return rows
}